import React from "react"
import Footer from "../components/Footer"
import Header from "../components/Header"
import PrimaryResourcesCategoryView from "../components/PrimaryResourcesCategoryView"
import PDFLogo from "../images/pdf.svg"
import ZipLogo from "../images/zip.svg"
import Grade2TB from "../images/primary-2.jpg"

class Primary2Resources extends React.Component {
  state = {
    view: {
      title: "Primary 2 Resources",
      parentURL: "/resources",
      parentName: "resources",
      categories: [
        {
          name: "Teacher's Book",
          file: Grade2TB,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/resources-nov-2022/G2-Primary-2-TB_WM_2022.pdf",
        },
        {
          name: "Flashcards",
          fileType: PDFLogo,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/resources-primary-2-jan-2021/",
          files: [
            {
              name: "Grade 2 Flashcards (Fronts)",
              file: "LBY0032_G2_Flashcards_Fronts_2020_FINAL.pdf",
            },
            {
              name: "Grade 2 Flashcards (Backs)",
              file: "LBY0032_G2_Flashcards_Backs_2020_FINAL.pdf",
            },
          ],
        },
        {
          name: "Posters",
          fileType: PDFLogo,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/resources-primary-2-jan-2021/",
          files: [
            {
              name: "Grade 2 Alphabet Poster",
              file: "LBY0032_G2_Alphabet_Poster_2020_FINAL.pdf",
            },
            {
              name: "Grade 2 Body Poster",
              file: "LBY0032_G2_Body_Poster_2020_FINAL.pdf",
            },
            {
              name: "Grade 2 Numbers Poster",
              file: "LBY0032_G2_Numbers_Poster_2020_FINAL.pdf",
            },
            {
              name: "Grade 2 House Poster",
              file: "LBY0032_G2_House_Poster_2020_FINAL.pdf",
            },
          ],
        },
        {
          name: "Audio",
          fileType: ZipLogo,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/audio-april-2022/",
          files: [{ name: "Grade 2 Audio", file: "Primary-2-audio.zip" }],
        },
      ],
    },
  }

  render() {
    return (
      <div>
        <Header />

        <PrimaryResourcesCategoryView data={this.state.view} />

        <Footer />
      </div>
    )
  }
}

export default Primary2Resources



// WEBPACK FOOTER //
// ./src/components/ResourcesPrimary2.js